module.exports = __webpack_public_path__ + "static/media/5.87f9cb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/roms/5.jpg
// module id = 950
// module chunks = 0